<template>
<div class="login_con container-fluid">
    <div style="display: flex; justify-content: center; align-item: center" class="container">
        <img class="side_one" src="../../assets/Rectangle 8.svg" alt="" srcset="">
        <div class="login_div">
            <div style="padding: 20px 0" class="">
                <img src="../../assets/motomoto.svg" alt="" srcset="">
            </div>
            <!-- <div class="text">
                <h4 class="text">Login in to your dashoard</h4>
            </div> -->
            <div class="field_div">
                <form action="#" @submit.prevent>
                    <div class="mb-3">
                        <input class="field_one" type="email" id="emailaddress" required="" placeholder="Enter your email" v-model="email">
                    </div>
                    <div class="mb-3">
                        <input class="field_one" type="password" required="" id="password" placeholder="Enter your password" v-model="password">
                    </div>
                    <div class="button mb-0 text-center">
                        <button class="button" type="submit" @click.prevent='login()'> Log In </button>
                    </div>
                </form>
            </div>
            <div style="margin: 40px 0">
                <router-link class="forgot_pass" to="/forgetPassword">
                    Forgot Password ?
                </router-link>
            </div>
        </div>
        <img class="side_two" src="../../assets/Rectangle 7.svg" alt="" srcset="">
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import Swal from 'sweetalert2'
///////// IMPORT COOKIE SERVICE
import cookieOps from "@/services/cookieOps.js";
import jwt_decode from "jwt-decode";
import httpRequest from "@/services/httpRequests.js";

/////////////////////////
import router from '@/router/index'

export default {

    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            // userInfo: this.$route.params.user,
        };
    },

    /// SCOPE METHODS
    methods: {
        //////// sweet allert serivice
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },
        ///// LOGIN FOR APPMART ADMIN
        login() {
            var thiss = this
            try {
                httpRequest.post('auth/loginadmin', {
                    email: this.email,
                    password: this.password,
                }).then((response) => {
                    // response = decoded
                    console.log(response)
                    if (response.data.code == '00') {
                        // set cookies
                        cookieOps.setCookie('app_init', response.data.token);

                        thiss.alertDisplay('Logged In', 'Login Successful', 'success');
                        console.log('Jeg')
                        const user = response.data.user;
                        this.$router.push({
                            path: `/appdashboard`,  query: { user }
                        });
                        // router.push('appdashboard')
                    } else {
                        thiss.alertDisplay('Invalid Login', 'Username or Password Wrong', 'error');
                    }

                })
                //this.alertDisplay();
            } catch (e) {
                console.log(e)
            }
        },

    }
}
</script>

<style scoped>
/* @import url(https://fonts.googleapis.com/css?family=Roboto:400, 500, 700);
@import url(https://fonts.googleapis.com/css?family=Karla:400, 700); */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap');

.login_con {
    text-align: center;
    position: relative;
    background: #555A6E;
    padding: 30px 0;
    margin: 0;
    height: 100vh;
    min-height: 100%;
}

@media (max-width: 1000px) {
    .login_con {
        text-align: center;
        position: relative;
        background: #555A6E;
        padding: 30px 0;
        margin: 0;
        height: 100%;
        min-height: 100%;
    }
}

.side_one {
    position: absolute;
    width: 550px;
    height: 550px;
    left: 0;
    top: 0;
}

.side_two {
    position: absolute;
    width: 550px;
    height: 550px;
    right: 0;
    bottom: 0;

}

@media (max-width: 1000px) {
    .side_one {
        display: none;
    }

    .side_two {
        display: none;
    }
}

.login_div {
    z-index: 1;
    padding: 20px 0;
    width: 50%;
    /* // margin-left: 30%; */
    margin-top: 50px;
    height: auto;
    background: #FFFFFF;
    border-radius: 18px;
}

@media (max-width: 1000px) {
    .login_div {
        padding: 20px 0;
        width: 100%;
        height: 100vh;
        /* // margin-left: 30%; */
        margin-top: 50px;
        height: auto;
        background: #FFFFFF;
        border-radius: 18px;
    }
}

.text {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 45px;
    color: #494949;
}

.field_div {
    text-align: center;
    margin-top: 8%;
    padding: 0 15%;
}

.field_one {
    padding: 25px;
    width: 100%;
    height: 23%;
    margin: 10px 0;
    background: #F7F7F7;
    ;
    border-radius: 4px;
    border: none;
}

.button {
    margin-top: 30px;

}

button {
    padding: 20px;
    width: 100%;
    height: 30%;
    background: #555A6E;
    border-radius: 4px;

    /* // Text */
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    border: none;
    color: #FFFFFF;
}

.forgot_pass {
    text-decoration: none;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #494949;

}
</style>
